import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import debounce from 'lodash.debounce';
import SearchGray from '../../../../img/search-icon.svg';

interface HeaderSearchContainerProps {
	active: boolean;
}

export const HeaderSearchContainer = styled.div<HeaderSearchContainerProps>`
	height: 40px;
	display: flex;
	flex-direction: row;

	background: #f0f0f0 0% 0% no-repeat padding-box;
	border-radius: 20px;
	border: 0;
	opacity: 1;
	align-items: center;
	min-width: 230px;

	margin-right: 24px;

	input {
		//display: ${(props) => !props.active && 'none'};
		transition: all 1s;
		width: ${(props) => (!props.active ? 0 : '230px')};
		// margin-left: ${(props) => (!props.active ? 0 : '16px')};
		padding: ${(props) => (!props.active ? 0 : '11px')};
	}

	button {
		cursor: pointer;
		padding: 11px;
		background: transparent;
		border: 0;
		display: flex;
		align-items: center;
	}

	svg {
		color: #09aa36;
		width: 16px;
		height: 16px;
	}
`;

export const HeaderSearchInput = styled.input`
	text-align: left;
	font: normal normal normal 14px/19px Roboto;
	letter-spacing: 0px;
	color: #9f9f9f;
	opacity: 1;
	flex: 1;
	border: 0;
	background-color: transparent;
	//padding:11px;
    outline:none;
`;

export function DebouncerInput({
	setSearchItem,
	placeholder,
	searchItem,
}: {
	setSearchItem(s: string): void;
	placeholder?: string;
	searchItem: string;
}) {
	const [searchInput, setSearchInput] = useState('');

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSave = useCallback(
		debounce((nextValue) => setSearchItem(nextValue), 1000),
		[]
	);

	function handleChange(s: string) {
		setSearchInput(s);
		debouncedSave(s);
	}

	useEffect(() => {
		if (searchItem !== searchInput) {
			setSearchInput(searchItem);
		}
	}, [searchItem]);

	return (
		<HeaderSearchContainer
			
			active={true}>
			<button>
				<img src={SearchGray} alt='src' style={{ width: 24, height: 24 }} />
			</button>

			<HeaderSearchInput
				value={searchInput}
				onChange={(e) => {
					//console.log(e.target.value)
					handleChange(e.target.value);
				}}
				placeholder={placeholder ? placeholder : ''}
			/>
		</HeaderSearchContainer>
	);
}
